import Dispatcher from "../dispatcher";

let _followers = {};
let _blocks = {};

const FollowersStore = {
  all() {
    const followers = this._sortByName(_followers);
    const blocks = this._sortByName(_blocks);
    return { followers, blocks };
  },

  _sortByName(object) {
    const result = [];
    for (let follower in object) {
      result.push(object[follower]);
    }
    return result.sort((a, b) =>
      a.full_name > b.full_name ? 1 : a.full_name < b.full_name ? -1 : 0
    );
  },

  _reset(followers, blocks) {
    // return;
    _followers = {};
    followers.forEach(follower => {
      _followers[follower.id] = follower;
    });
    _blocks = {};
    blocks.forEach(block => {
      _blocks[block.id] = block;
    });
    Dispatcher.emit(Dispatcher.FOLLOWER_STORE_CHANGE);
  },

  _block(followerId, block) {
    delete _followers[followerId];
    _blocks[block.id] = block;
    Dispatcher.emit(Dispatcher.FOLLOWER_STORE_CHANGE);
  },

  _unblock(blockId, data) {
    delete _blocks[blockId];
    if (data.was_blocked) {
      _followers[data.id] = data;
    }
    Dispatcher.emit(Dispatcher.FOLLOWER_STORE_CHANGE);
  },

  init() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 3);

    Dispatcher.bind(
      Dispatcher.RECEIVE_FOLLOWERS_AND_BLOCKS,
      (followers, blocks) => {
        this._reset(followers, blocks);
      }
    );
    Dispatcher.bind(Dispatcher.FOLLOWER_BLOCKED, (id, block) => {
      this._block(id, block);
    });
    Dispatcher.bind(Dispatcher.USER_UNBLOCKED, (id, data) => {
      this._unblock(id, data);
    });
  }
};

FollowersStore.init();

export default FollowersStore;
